import React, { useState } from 'react';
import agents from '../data/agents.json';
import './Dashboard.css';

const Dashboard = ({ user, onLogout, onStartDemo }) => {
  const [hoveredAgent, setHoveredAgent] = useState(null);

  return (
    <div className="dashboard-container">
      {/* Header */}
      <header className="dashboard-header">
        <div className="dashboard-header-left">
          <div className="dashboard-logo">
            <div className="dashboard-logo-icon">R</div>
            <div className="dashboard-logo-text">
              <span className="dashboard-logo-title">RMB Corporate Finance</span>
              <span className="dashboard-logo-subtitle">AI Agents Platform</span>
            </div>
          </div>
        </div>
        
        <div className="dashboard-header-right">
          <div className="dashboard-user">
            <div className="dashboard-user-avatar">{user.avatar}</div>
            <div className="dashboard-user-info">
              <span className="dashboard-user-name">{user.name}</span>
              <span className="dashboard-user-role">{user.role}</span>
            </div>
          </div>
          <button className="dashboard-logout" onClick={onLogout}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Sign Out
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="dashboard-main">
        {/* Agents Grid */}
        <div className="dashboard-agents-grid">
          {agents.agents.map((agent, index) => (
            <div
              key={agent.id}
              className={`dashboard-agent-card ${hoveredAgent === agent.id ? 'hovered' : ''} ${index < 2 ? 'ready' : 'coming-soon'}`}
              onMouseEnter={() => setHoveredAgent(agent.id)}
              onMouseLeave={() => setHoveredAgent(null)}
              onClick={() => index < 2 && onStartDemo(agent.id)}
            >
              {/* Status Badge */}
              <div className={`dashboard-agent-status ${index < 2 ? 'ready' : 'coming-soon'}`}>
                {index < 2 ? (
                  <>
                    <span className="status-dot active" />
                    Ready to Demo
                  </>
                ) : (
                  'Coming Soon'
                )}
              </div>

              {/* Content */}
              <h3 className="dashboard-agent-name">{agent.name}</h3>
              <p className="dashboard-agent-tagline">{agent.tagline}</p>

              {/* Sub-agents count */}
              <div className="dashboard-agent-meta">
                <span className="dashboard-agent-subcount">{agent.subAgents.length} Sub-Agents</span>
              </div>

              {/* Action */}
              {index < 2 ? (
                <button className="dashboard-agent-button">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="5 3 19 12 5 21 5 3" />
                  </svg>
                  Start Demo
                </button>
              ) : (
                <div className="dashboard-agent-button disabled">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  Coming Soon
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Info Cards */}
        <div className="dashboard-info-cards">
          <div className="dashboard-info-card">
            <div className="dashboard-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div className="dashboard-info-content">
              <h4>200+ Second Demo</h4>
              <p>Full walkthrough with live commentary</p>
            </div>
          </div>
          <div className="dashboard-info-card">
            <div className="dashboard-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 3v18h18" />
                <path d="M18 17V9" />
                <path d="M13 17V5" />
                <path d="M8 17v-3" />
              </svg>
            </div>
            <div className="dashboard-info-content">
              <h4>Real-time Statistics</h4>
              <p>Documents, API calls, token consumption</p>
            </div>
          </div>
          <div className="dashboard-info-card">
            <div className="dashboard-info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <div className="dashboard-info-content">
              <h4>Expert Commentary</h4>
              <p>Detailed explanations of each step</p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="dashboard-footer">
        <div className="dashboard-footer-left">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span>This is end-to-end visual representation of Agents with dummy data.</span>
        </div>
        <div className="dashboard-footer-right">
          <span>Built by Applied Cloud Computing (ACC)</span>
          <span className="dashboard-footer-separator">|</span>
          <span>AWS GenAI Competency Partner</span>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;
